import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { apiClient } from "../../api";
import { BENEFICIARIES_API_RESPONSE } from "./types";
import keys from "./keys";

interface GetBeneficiariesReturnType {
  isLoading: boolean;
  data: BENEFICIARIES_API_RESPONSE | null;
  isSuccess: boolean;
  error: unknown;
}

export const beneficiariesResourcePath = "beneficiaries/user";

const useGetBeneficiaries = (url: string): GetBeneficiariesReturnType => {
  const hash = [keys.read, `${url}`];
  const {
    isLoading,
    data = null,
    isSuccess,
    error,
  }: UseQueryResult<BENEFICIARIES_API_RESPONSE | null, unknown> = useQuery(
    hash,
    async () =>
      await apiClient.get({
        url,
      }),
  );
  return { isLoading, data, isSuccess, error };
};

export { useGetBeneficiaries };
